import classNames from 'classnames';
import styled from 'styled-components';

import paypalLogo from 'assets/paypal.svg';
import { Horizontal } from 'atoms/layout/flex';
import { BodyM } from 'atoms/typography';

const PayPalLogo = styled.img`
  display: flex;
  height: var(--triple-unit);
  width: 40px;
  background-color: var(--c-nd-900);
  padding: 2px;
  border-radius: var(--half-unit);
  object-fit: contain;
  object-position: center;
`;

const Root = styled(Horizontal)`
  &.column {
    flex-direction: column;
    gap: var(--half-unit);
  }
`;

export const Paypal = ({ column }: { column?: boolean }) => {
  return (
    <Root className={classNames({ column })}>
      <PayPalLogo src={paypalLogo} alt="PayPal" />
      <BodyM color="var(--c-white)">PayPal</BodyM>
    </Root>
  );
};
